<div>
    @let prod = formReportData?.prod?.excursionDetails;
    @let affectedProductList = formReportData?.prod?.affectedProductList;
    @let capa = formReportData?.capa?.capaDetails;
    @let capaFiles = formReportData?.capa?.documents;
    @let eval = formReportData?.eval?.evalDispDetails;

    <ng-container *ngIf="(!prod && !capa && !eval) || (formReportData?.prod?.excursionDetails | keyvalue).length === 0 && (formReportData?.capa?.capaDetails | keyvalue).length === 0 && (formReportData?.eval?.evalDispDetails | keyvalue).length === 0">
        <div class="flex flex-col space-y-4 m-2 p-4 rounded-lg items-center justify-center">
            <nz-empty [nzNotFoundContent]="'No data found'"></nz-empty>
        </div>
    </ng-container>

    <ng-container *ngIf="prod && (formReportData?.prod?.excursionDetails | keyvalue).length > 0">
        <nz-divider nzText="Incident Details"></nz-divider>
        <div class="flex flex-col space-y-4 p-4 rounded-lg border border-gray-200">
            <nz-row [nzGutter]="[8,8]">
                <nz-col [nzSpan]="12">
                    <div class="border rounded-lg p-2 flex items-center gap-2">
                        <span class="rounded-full border-2 flex items-center justify-center w-7 h-7 text-lg" [ngClass]="{
                                          'border-[#12B76A] bg-[#12B76A] text-white': prod?.isImpacted === 'Yes',
                                          'border-[#F04438] bg-[#F04438] text-white': prod?.isImpacted === 'No',
                                          'border-[#98A2B3] bg-[#F2F4F7] text-[#98A2B3]': !prod?.isImpacted
                                        }">
                            <i nz-icon nzType="check-circle" *ngIf="prod?.isImpacted === 'Yes'" class="text-white"></i>
                            <i nz-icon nzType="close-circle" *ngIf="prod?.isImpacted === 'No'" class="text-white"></i>
                            <i nz-icon nzType="info-circle" *ngIf="!prod?.isImpacted" class="text-[#98A2B3]"></i>
                        </span>
                        <span class="text-xs">
                            <span class="font-medium ">Product Impact</span>
                            <span class="block text-[#667085]">Impacted?</span>
                        </span>
                        <span class="ml-auto">
                            <span *ngIf="prod?.isImpacted === 'Yes'"
                                class="px-2 py-0.5 rounded bg-[#F6FEF9] text-[#039855] border border-[#A6F4C5] text-xs font-semibold">Yes</span>
                            <span *ngIf="!prod?.isImpacted || prod?.isImpacted === 'No'"
                                class="px-2 py-0.5 rounded bg-[#FEF3F2] text-[#F04438] border border-[#FDA29B] text-xs font-semibold">No</span>
                        </span>
                    </div>
                </nz-col>
                <nz-col [nzSpan]="12">
                    <div class="border rounded-lg p-2 flex items-center gap-2">
                        <span class="rounded-full border-2 flex items-center justify-center w-7 h-7 text-lg" [ngClass]="{
                                            'border-[#2E90FA] bg-[#2E90FA] text-white': prod?.shiftedYesNo === 'Yes',
                                          'border-[#F04438] bg-[#F04438] text-white': prod?.shiftedYesNo === 'No',
                                          'border-[#98A2B3] bg-[#F2F4F7] text-[#98A2B3]': !prod?.shiftedYesNo
                                        }">
                            <i nz-icon nzType="export" *ngIf="prod?.shiftedYesNo === 'Yes'" class="text-white"></i>
                            <i nz-icon nzType="close-circle" *ngIf="prod?.shiftedYesNo === 'No'" class="text-white"></i>
                            <i nz-icon nzType="info-circle" *ngIf="!prod?.shiftedYesNo" class="text-[#98A2B3]"></i>
                        </span>
                        <span class="text-xs">
                            <span class="font-medium">Relocation</span>
                            <span class="block text-[#667085]">Shifted?</span>
                        </span>
                        <span class="ml-auto">
                            <span *ngIf="prod?.shiftedYesNo === 'Yes'"
                                class="px-2 py-0.5 rounded bg-[#F5FAFF] text-[#1570EF] border border-[#B2DDFF] text-xs font-semibold">Yes</span>
                            <span *ngIf="!prod?.shiftedYesNo || prod?.shiftedYesNo === 'No'"
                                class="px-2 py-0.5 rounded bg-[#FEF3F2] text-[#F04438] border border-[#FDA29B] text-xs font-semibold">No</span>
                        </span>
                    </div>
                </nz-col>
                <nz-col  [nzSpan]="24" *ngIf="prod?.shiftedYesNo == 'Yes' && feUtil.appId === 2">
                    <div class="border border-[#E0E7EF] rounded-lg p-2 flex flex-col space-y-1 shadow-sm">
                        <div class="flex items-center gap-2">
                            <span class="text-xs font-medium text-[#4B5563]">Shifted To:</span>
                            <ng-container>
                                <span *ngIf="prod?.shiftedTo == 'Truck'"
                                    class="px-2 py-0.5 rounded-full bg-[#EFF8FF] text-[#175CD3] border border-[#B2DDFF] text-xs font-semibold flex items-center gap-1">
                                    <i nz-icon nzType="car" class="text-[#175CD3]"></i>
                                    Truck
                                </span>
                                <span *ngIf="prod?.shiftedTo == 'Area'"
                                    class="px-2 py-0.5 rounded-full bg-[#FEF6F8] text-[#D92D20] border border-[#FDA29B] text-xs font-semibold flex items-center gap-1">
                                    <i nz-icon nzType="environment" class="text-[#D92D20]"></i>
                                    Area
                                </span>
                            </ng-container>
                        </div>
                        <div *ngIf="prod?.shiftDatetime" class="flex items-center gap-2 mt-1">
                            <span class="text-xs font-medium text-[#4B5563]">Date & Time Shifted:</span>
                            <span class="text-xs text-gray-600 flex items-center gap-1">
                                {{ prod.shiftDatetime | gDate }}
                            </span>
                        </div>
                    </div>
                </nz-col>
            </nz-row>
            <div>
                <label class="block text-xs font-medium  mb-1">Details:</label>
                <div class="border  bg-[#F9FAFB] rounded-lg px-3 py-2 w-full text-xs  min-h-[40px]">
                    {{ prod?.immedCorrDetail || '-' }}
                </div>
            </div>
            <div *ngIf="feUtil.appId === 2">
                <label class="block text-xs font-medium  mb-1">Shifted to detail:</label>
                <div class="border  bg-[#F9FAFB] rounded-lg px-3 py-2 w-full text-xs  min-h-[40px]">
                    {{ prod?.shiftTargetName || '-' }}
                </div>
            </div>
            <div *ngIf="prod?.isImpacted === 'Yes' && affectedProductList?.length > 0">
                <div class="font-semibold text-[#B42318] text-sm mb-2">Affected Products</div>
                <nz-table #affectedProductsTable [nzData]="affectedProductList || []" [nzSize]="'small'"
                    [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ y: '300px', x: '100%' }">
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>Batch No.</th>
                            <th>No. Of Units Affected</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let p of affectedProductsTable.data">
                            <td>{{ p?.product_name || '-' }}</td>
                            <td>{{ p?.batch_no || '-' }}</td>
                            <td>{{ p?.units_affected || '-' }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="capa && (formReportData?.capa?.capaDetails | keyvalue).length > 0">
        <nz-divider nzText="CAPA Form"></nz-divider>
        <div class="flex flex-col space-y-4 p-4 rounded-lg border border-gray-200">
            <div class="border rounded-lg p-2" *ngIf="feUtil.appId === 2">
                <nz-row [nzGutter]="[16,16]">
                    <nz-col [nzSpan]="8">
                        <div>
                            <span class="block text-xs  font-medium mb-1">Was the vehicle sealed?</span>
                            <span *ngIf="capa?.isVehicleSealed === 'Yes'"
                                class="px-2 py-0.5 rounded bg-[#F6FEF9] text-[#039855] border border-[#A6F4C5] text-xs font-semibold">Yes</span>
                            <span *ngIf="!capa?.isVehicleSealed || capa?.isVehicleSealed === 'No'"
                                class="px-2 py-0.5 rounded bg-[#FEF3F2] text-[#F04438] border border-[#FDA29B] text-xs font-semibold">No</span>
                        </div>
                    </nz-col>
                    <nz-col [nzSpan]="8">
                        <div>
                            <span class="block text-xs  font-medium mb-1">Was the cooling working when vehicle was received and being updated at CFA/HUB ?</span>
                            <span *ngIf="capa?.isCoolingWorking === 'Yes'"
                                class="px-2 py-0.5 rounded bg-[#F6FEF9] text-[#039855] border border-[#A6F4C5] text-xs font-semibold">Yes</span>
                            <span *ngIf="!capa?.isCoolingWorking || capa?.isCoolingWorking === 'No'"
                                class="px-2 py-0.5 rounded bg-[#FEF3F2] text-[#F04438] border border-[#FDA29B] text-xs font-semibold">No</span>
                        </div>
                    </nz-col>
                    <nz-col [nzSpan]="8">
                        <div>
                            <span class="block text-xs  font-medium mb-1">Discuss with driver to find out if vehicle or cooling unit malfunctioned during transit?</span>
                            <span *ngIf="capa?.isMalfunctionReported === 'Yes'"
                                class="px-2 py-0.5 rounded bg-[#F6FEF9] text-[#039855] border border-[#A6F4C5] text-xs font-semibold">Yes</span>
                            <span *ngIf="!capa?.isMalfunctionReported || capa?.isMalfunctionReported === 'No'"
                                class="px-2 py-0.5 rounded bg-[#FEF3F2] text-[#F04438] border border-[#FDA29B] text-xs font-semibold">No</span>
                        </div>
                    </nz-col>
                </nz-row>
            </div>
            <div>
                <nz-row [nzGutter]="[16,16]">
                    <nz-col [nzSpan]="12" *ngIf="capa?.isMalfunctionReported === 'Yes' && feUtil.appId === 2">
                        <div>
                            <label class="block text-xs font-medium mb-1">Reason for Excursion:</label>
                            <div class="border rounded px-3 py-2 text-xs bg-white min-h-[36px]">
                                {{ capa?.reasonForExcursion || '-' }}
                            </div>
                        </div>
                    </nz-col>

                    <nz-col [nzSpan]="12" *ngIf="feUtil.appId === 1">
                        <div>
                            <label class="block text-xs font-medium mb-1">Reason for Excursion:</label>
                            <div class="border rounded px-3 py-2 text-xs bg-white min-h-[36px]">
                                {{ capa?.reasonForExcursion || '-' }}
                            </div>
                        </div>
                    </nz-col>
                    
                    <nz-col [nzSpan]="12">
                        <div>
                            <label class="block text-xs font-medium  mb-1">CAPA Implementation Date:</label>
                            <div
                                class="border rounded px-3 py-2 text-xs  bg-white min-h-[36px] flex items-center gap-2">
                                <i nz-icon nzType="calendar"></i>
                                {{ capa?.capaImpDate ? (capa?.capaImpDate | gDate: 'MMM d, yyyy') : '-' }}
                            </div>
                        </div>
                    </nz-col>
                </nz-row>
            </div>
            <div>
                <label class="block text-xs font-medium mb-1"> {{ feUtil.appId === 2 ? 'CAPA Details:' : 'Excursion Details:'}} </label>
                <div class="border  bg-[#F9FAFB] rounded-lg px-3 py-2 text-xs">
                    {{ capa?.details || '-' }}
                </div>
            </div>
            <div *ngIf="feUtil.appId === 1">
                <label class="block text-xs font-medium mb-1"> Details:</label>
                <div class="border  bg-[#F9FAFB] rounded-lg px-3 py-2 text-xs">
                    {{ capa?.comment || '-' }}
                </div>
            </div>
            <div>
                <nz-divider nzText="Documents Attached" class="!my-0 py-0"></nz-divider>
                <div *ngIf="capaFiles && capaFiles?.length > 0; else noDocs">
                    <ol class="list-decimal ml-6 text-xs space-y-1">
                        <li *ngFor="let doc of capaFiles; let idx = index" class="flex items-center gap-2">
                            <span class="font-medium text-gray-500">{{ idx + 1 }}.</span>
                            <a [href]="doc?.doc_link" target="_blank" class="text-[#2E90FA] hover:underline break-all">
                                {{ doc?.doc_name }}
                            </a>
                        </li>
                    </ol>
                </div>
                <ng-template #noDocs>
                    <div class="text-xs text-center text-[#98A2B3] p-2">No documents attached.</div>
                </ng-template>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="eval && (formReportData?.eval?.evalDispDetails | keyvalue).length > 0">
        <nz-divider nzText="Evaluation Disposition"></nz-divider>
        <div class="flex flex-col space-y-4 p-4 rounded-lg border border-gray-200">
            <nz-row [nzGutter]="[8,8]">
                <nz-col [nzSpan]="12">
                    <div class="border rounded-lg p-2 flex items-center gap-2">
                        <span class="text-xs">
                            <span class="font-medium ">Product Disposition:</span>
                        </span>
                        <span
                            class="inline-block px-2 py-0.5 rounded-full bg-[#E0F2FE] text-[#0369A1] text-xs font-semibold border border-[#BAE6FD]">
                            {{ eval?.productDisposition || '-' }}
                        </span>
                    </div>
                </nz-col>
            </nz-row>
            <div>
                <label class="block text-xs font-medium  mb-1">Details:</label>
                <div class="border  bg-[#F9FAFB] rounded px-3 py-2 w-full text-xs  min-h-[40px]">
                    {{ eval?.impactAssessment || '-' }}
                </div>
            </div>
            <div  *ngIf="prod?.isImpacted === 'Yes' && affectedProductList?.length > 0">
                <div class="font-semibold text-[#B42318] text-sm mb-2">Affected Products</div>
                <nz-table #affectedProductsTable [nzData]="affectedProductList || []" [nzSize]="'small'"
                    [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ y: '300px', x: '100%' }">
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>Batch No.</th>
                            <th>No. Of Units Affected</th>
                            <th>Action Taken</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let p of affectedProductsTable.data">
                            <td>{{ p?.product_name || '-' }}</td>
                            <td>{{ p?.batch_no || '-' }}</td>
                            <td>{{ p?.units_affected || '-' }}</td>
                            <td>
                                <ng-container [ngSwitch]="p?.isSelected">
                                    <span *ngSwitchCase="1" class="px-2 py-0.5 rounded bg-success/10 text-success border border-success text-xs">Released</span>
                                    <span *ngSwitchCase="-1" class="px-2 py-0.5 rounded bg-danger/10 text-danger border border-danger text-xs">Rejected</span>
                                    <span *ngSwitchDefault>-</span>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </ng-container>
</div>